import { ChevronRight } from 'lucide-react'
import { Link } from 'react-router-dom'
import { SectionHead } from './shared'
import type { Agent } from './index'
import { useFadeIn } from './useFadeIn'

export default function LandingAgents({ agents, loading }: { agents: Agent[]; loading: boolean }) {
  const fadeRef = useFadeIn<HTMLElement>()
  return (
    <section className="lp-section" ref={fadeRef}>
      <div className="lp-wrap">
        <SectionHead badge="Agents" title="Meet the team" sub="Platform agents are always on. User agents join the workforce." />
        <div className="lp-agents-grid">
          {loading
            ? Array.from({ length: 8 }).map((_, i) => <div key={i} className="lp-skel lp-skel-agent" />)
            : agents.slice(0, 8).map(a => (
              <Link key={a.id} to={`/agent/${a.id}`} className="lp-agent-card">
                <div className="lp-agent-av" style={{ background: `hsl(${(a.id * 47) % 360},55%,42%)` }}>{a.agent_name.charAt(0)}</div>
                <div className="lp-agent-name">{a.agent_name}</div>
                <div className="lp-agent-tasks">{a.tasks_completed ?? 0} tasks</div>
                <div className={`lp-agent-dot lp-dot-${a.status}`} />
              </Link>
            ))
          }
        </div>
        <div className="lp-cta-row"><Link to="/agents" className="lp-link-btn">Browse all agents <ChevronRight size={13} /></Link></div>
      </div>
    </section>
  )
}
